import { Avatar, Drawer, Menu } from "antd";
import React, { useEffect, useState } from "react";
import {
  adminItems,
  newUserItems,
  userItems,
} from "../../Assets/ListItems/SideNavbarMenu";
import { useLocation, useNavigate } from "react-router-dom";

export default function MobileSideNavbar({
  isNavbarOpen,
  setIsNavbarOpen,
  type,
}) {
  const location = useLocation(null);
  const navigate = useNavigate(null);

  useEffect(() => {
    setCurrentKey(
      location.state?.selectedKey !== null ? location.state?.selectedKey : [""]
    );
    setOpenKeys(
      location.state?.openedKeys !== null ? location.state?.openedKeys : [""]
    );
  }, [location.state?.selectedKey, location.state?.openedKeys]);

  const [currentKey, setCurrentKey] = useState([""]);
  const [openKeys, setOpenKeys] = useState([""]);

  const onClick = (e) => {
    setCurrentKey(e.key);
    navigate(`/${type}/${e.key}`, {
      state: { selectedKey: e.key, openedKeys: [e.keyPath[1]] },
    });
    setIsNavbarOpen(false);
  };

  const onOpenChange = (keys) => {
    var i = keys.indexOf(openKeys[0]);
    if (i !== -1) {
      keys.splice(i, 1);
    }
    setOpenKeys(keys);
  };

  const onClose = () => {
    setIsNavbarOpen(false);
  };

  return (
    <Drawer
      width={"80%"}
      title="Navigation"
      placement="left"
      closable={true}
      onClose={onClose}
      open={isNavbarOpen}
      key="left"
      extra={
        <div>
          <Avatar className="bg-info">
            <span className="fw-bold">
              {sessionStorage.getItem("firstName") !== null &&
                `${sessionStorage?.getItem("firstName")[0]}${
                  sessionStorage?.getItem("lastName")[0]
                }`}
            </span>
          </Avatar>
        </div>
      }
    >
      <Menu
        className="custom-menu"
        mode="inline"
        selectedKeys={currentKey}
        onClick={onClick}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        style={{
          width: "100%",
        }}
        items={
          type === "admin"
            ? adminItems
            : type === "user"
            ? userItems
            : newUserItems
        }
      />
    </Drawer>
  );
}
